import { SalesFlowType } from '~/App/shared/types/SalesFlowType';
import { SELL_FLOWS } from '~/config/constants';

/**
 * Determines if valuations should be hidden for corporate cars based on feature flag and sales flow
 * @param hideValuationsForCorporateCars - Feature flag value (boolean)
 * @param salesFlow - The sales flow type
 * @returns true if valuations should be hidden, false otherwise
 */
export const shouldHideValuationsForCorporateCars = (
  hideValuationsForCorporateCars: boolean,
  salesFlow?: SalesFlowType
): boolean => {
  return (
    Boolean(hideValuationsForCorporateCars) &&
    (salesFlow === SELL_FLOWS.CORPORATE_CARS_SMALL ||
      salesFlow === SELL_FLOWS.CORPORATE_CARS)
  );
};
